import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Icon, Spinner } from 'ui/atoms';
import { connect } from 'react-redux';
import { TOGGLE_SIDEBAR } from 'redux/slices/sidebar';

import theme from 'ui/theme';
import MainFont from 'ui/typography/mainFont';

import SearchSection from './SearchSection';
import {
  AddButtonWrapper,
  AddIconWrapper,
  AdvancedSearchButton,
  ContentWrapper,
  DownArrow,
  DownloadCsvIcon,
  IconBack,
  IconWrapper,
  InputContainer,
  ItemContainer,
  PageContainer,
  SearchContainer,
  SideBarWrapper,
  SideButton,
  TableContainer,
  TitleContainer
} from './style';
import { AdvancedSearch } from 'ui/components';

const CrudLayout = ({
  title,
  description,
  subDescription,
  dropdowns,
  onSubmitDropdown,
  searchPlaceholder,
  onSubmitSearch,
  searchValue,
  children,
  Sidebar,
  sidebarType,
  callbackSidebar,
  sidebarOpen,
  toggleSidebar,
  onDownloadCsv,
  onSubmitAdvancedSearch,
  advancedSearchFields,
  advancedSearchValues,
  onSubmitAdvancedChange,
  resetAdvancedSearch
}) => {
  //  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const { t } = useTranslation();

  const toggleSideBar = () => {
    setRefresh(true);
    toggleSidebar();
    if (callbackSidebar) {
      callbackSidebar(!sidebarOpen);
    }
    setTimeout(() => setRefresh(false), 500);
  };

  useEffect(() => {
    if (sidebarOpen && showAdvancedSearch) {
      setShowAdvancedSearch(false);
    }
    if (!showAdvancedSearch && resetAdvancedSearch) {
      resetAdvancedSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAdvancedSearch, sidebarOpen]);

  return (
    <PageContainer>
      <TitleContainer>
        <div>
          {title && (
            <ItemContainer>
              <MainFont type="title">{title}</MainFont>
            </ItemContainer>
          )}
          {description && (
            <ItemContainer>
              <MainFont type="description">{description}</MainFont>
            </ItemContainer>
          )}
          {subDescription && (
            <ItemContainer>
              <MainFont type="subDescription">{subDescription}</MainFont>
            </ItemContainer>
          )}
        </div>{' '}
        <div>
          {onDownloadCsv && (
            <DownloadCsvIcon className="icon-download1" onClick={onDownloadCsv}>
              <span type="icon-download1" size="24" />
              <MainFont
                type="bold"
                configuration={{
                  fontSize: 12,
                  lineHeight: 1.5,
                  letterSpacing: '2px'
                }}
              >
                {t('download_data')}
              </MainFont>
            </DownloadCsvIcon>
          )}
        </div>
      </TitleContainer>
      {(dropdowns?.length > 0 || onSubmitSearch || Sidebar) && (
        <SearchContainer>
          {sidebarOpen ? (
            <>
              {dropdowns.length > 0 && (
                <InputContainer isSideBarOpen={sidebarOpen}>
                  <IconWrapper>
                    <Icon
                      type="icon-panel"
                      size="28"
                      color={theme().colors.white}
                      onClick={toggleSideBar}
                    />
                  </IconWrapper>
                </InputContainer>
              )}
              {onSubmitSearch && (
                <InputContainer isSideBarOpen={sidebarOpen} type="search">
                  <IconWrapper>
                    <Icon
                      type="icon-search"
                      size="28"
                      color={theme().colors.white}
                      onClick={toggleSideBar}
                    />
                  </IconWrapper>
                </InputContainer>
              )}
            </>
          ) : (
            <>
              <SearchSection
                dropdowns={dropdowns}
                onSubmitDropdown={onSubmitDropdown}
                searchPlaceholder={searchPlaceholder}
                onSubmitSearch={onSubmitSearch}
                searchValue={searchValue}
              />
              {Sidebar && (
                <AddButtonWrapper type="button" onClick={toggleSideBar}>
                  <AddIconWrapper>
                    <Icon
                      type="icon-close"
                      size="12"
                      color={theme().colors.statusGreen}
                      rotate={45}
                    />
                  </AddIconWrapper>
                  <MainFont type="addButton">{t('add')}</MainFont>
                </AddButtonWrapper>
              )}
            </>
          )}
          {onSubmitAdvancedSearch && (
            <AdvancedSearchButton
              onClick={() => {
                setShowAdvancedSearch(!showAdvancedSearch);
              }}
            >
              <IconWrapper>
                <Icon
                  type="icon-search"
                  size="28"
                  color={theme().colors.white}
                />
                <DownArrow upsideDown={showAdvancedSearch} />
              </IconWrapper>
            </AdvancedSearchButton>
          )}
        </SearchContainer>
      )}
      {onSubmitAdvancedSearch && (
        <AdvancedSearch
          height={showAdvancedSearch ? 190 : 0}
          advancedSearchFields={advancedSearchFields}
          onSubmitAdvancedSearch={onSubmitAdvancedSearch}
          onSubmitAdvancedChange={onSubmitAdvancedChange}
          advancedSearchValues={advancedSearchValues}
        />
      )}
      <ContentWrapper>
        <TableContainer>{refresh ? <Spinner /> : children}</TableContainer>

        {sidebarOpen && (
          <SideBarWrapper type={sidebarType}>
            <SideButton onClick={toggleSideBar}>
              <IconBack className="icon-up" />
            </SideButton>
            <Sidebar callbackOnclose={toggleSideBar} />
          </SideBarWrapper>
        )}
      </ContentWrapper>
    </PageContainer>
  );
};

CrudLayout.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  subDescription: PropTypes.string,
  children: PropTypes.node,
  Sidebar: PropTypes.object,
  sidebarType: PropTypes.string,
  callbackSidebar: PropTypes.func,
  onDownloadCsv: PropTypes.func,
  onSubmitAdvancedSearch: PropTypes.func,
  advancedSearchFields: PropTypes.array,
  onSubmitAdvancedChange: PropTypes.func,
  advancedSearchValues: PropTypes.object,
  resetAdvancedSearch: PropTypes.func,
  ...SearchSection.propTypes
};

export default connect(
  state => ({
    sidebarOpen: state.sidebar.sidebarOpen
  }),
  dispatch => ({
    toggleSidebar: () => dispatch(TOGGLE_SIDEBAR())
  })
)(CrudLayout);
